export default __webpack_public_path__ + "static/media/laus-profile1.6b6ba1ed.png";